/**
 * BudChampion Localisation — switcher behaviour.
 *
 * The language dropdown works without JavaScript via <details>. This file:
 *  - closes an open dropdown when clicking outside it or pressing Escape
 *  - restyles the CURCY #currency_converter <select> to match the language UI
 */
(function () {
	'use strict';

	function closeAll(except) {
		document
			.querySelectorAll('.bc-l10n-switcher__details[open]')
			.forEach(function (details) {
				if (details !== except) {
					details.removeAttribute('open');
				}
			});
	}

	document.addEventListener('click', function (event) {
		var details = event.target.closest('.bc-l10n-switcher__details');
		closeAll(details);
	});

	document.addEventListener('keydown', function (event) {
		if (event.key === 'Escape') {
			closeAll(null);
		}
	});

	/**
	 * Rebuild CURCY's native <select> as a language-switcher twin.
	 */
	function enhanceCurrencyConverter() {
		var form = document.getElementById('currency_converter');
		if (!form || form.getAttribute('data-bc-enhanced') === '1') {
			return;
		}

		var select = form.querySelector('#currency_switcher, select.currency_switcher');
		if (!select || !select.options || !select.options.length) {
			return;
		}

		form.setAttribute('data-bc-enhanced', '1');
		form.classList.add('bc-l10n-currency');

		var label = form.querySelector('.currency_switcher_label, label[for="currency_switcher"]');
		if (label) {
			label.classList.add('bc-l10n-currency__sr-only');
		}
		select.classList.add('bc-l10n-currency__sr-only');
		select.setAttribute('tabindex', '-1');
		select.setAttribute('aria-hidden', 'true');

		var wrap = document.createElement('div');
		wrap.className = 'bc-l10n-switcher bc-l10n-switcher--dropdown bc-l10n-currency-switcher';

		var details = document.createElement('details');
		details.className = 'bc-l10n-switcher__details';

		var summary = document.createElement('summary');
		summary.className = 'bc-l10n-switcher__toggle';
		summary.setAttribute(
			'aria-label',
			(label && label.textContent.trim()) || 'Choose a currency'
		);

		var currentLabel = document.createElement('span');
		currentLabel.className = 'bc-l10n-switcher__label';

		var caret = document.createElement('span');
		caret.className = 'bc-l10n-switcher__caret';
		caret.setAttribute('aria-hidden', 'true');

		summary.appendChild(currentLabel);
		summary.appendChild(caret);

		var list = document.createElement('ul');
		list.className = 'bc-l10n-switcher__list';

		function selectedOption() {
			return select.options[select.selectedIndex] || select.options[0];
		}

		function syncLabel() {
			var option = selectedOption();
			currentLabel.textContent = option ? option.textContent.trim() : '';
		}

		function buildList() {
			list.textContent = '';
			Array.prototype.forEach.call(select.options, function (option) {
				var item = document.createElement('li');
				item.className = 'bc-l10n-switcher__item';
				if (option.selected || option.value === select.value) {
					item.className += ' bc-l10n-switcher__item--current';
				}

				var button = document.createElement('button');
				button.type = 'button';
				button.className = 'bc-l10n-switcher__link';
				button.setAttribute('translate', 'no');
				button.setAttribute('data-value', option.value);
				if (option.selected || option.value === select.value) {
					button.setAttribute('aria-current', 'true');
				}

				var text = document.createElement('span');
				text.className = 'bc-l10n-switcher__label';
				text.textContent = option.textContent.trim();
				button.appendChild(text);

				button.addEventListener('click', function (event) {
					event.preventDefault();
					if (select.value === option.value) {
						details.removeAttribute('open');
						return;
					}
					select.value = option.value;
					syncLabel();
					buildList();
					details.removeAttribute('open');

					// Let CURCY / theme handlers run.
					select.dispatchEvent(new Event('change', { bubbles: true }));
					if (typeof window.jQuery === 'function') {
						window.jQuery(select).trigger('change');
					}
				});

				item.appendChild(button);
				list.appendChild(item);
			});
		}

		details.appendChild(summary);
		details.appendChild(list);
		wrap.appendChild(details);

		// Prefer placing the custom UI after the hidden native controls.
		form.appendChild(wrap);

		syncLabel();
		buildList();

		select.addEventListener('change', function () {
			syncLabel();
			buildList();
		});
	}

	function boot() {
		enhanceCurrencyConverter();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}

	// Header widgets / deferred CURCY markup.
	window.setTimeout(boot, 0);
	window.setTimeout(boot, 500);
})();
